var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 8.5C2.66406 5.55372 2.66406 4.08058 3.57936 3.16529C4.49464 2.25 5.96778 2.25 8.91406 2.25C11.8603 2.25 13.3335 2.25 14.2487 3.16529C15.1641 4.08058 15.1641 5.55372 15.1641 8.5",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 9.75C2.66406 7.99981 2.66406 7.12476 3.00467 6.45628C3.30427 5.86827 3.78234 5.39021 4.37034 5.09061C5.03882 4.75 5.9139 4.75 7.66406 4.75H10.1641C11.9143 4.75 12.7893 4.75 13.4578 5.09061C14.0458 5.39021 14.5239 5.86827 14.8234 6.45628C15.1641 7.12476 15.1641 7.99981 15.1641 9.75C15.1641 11.5002 15.1641 12.3752 14.8234 13.0437C14.5239 13.6317 14.0458 14.1098 13.4578 14.4094C12.7893 14.75 11.9143 14.75 10.1641 14.75H7.66406C5.9139 14.75 5.03882 14.75 4.37034 14.4094C3.78234 14.1098 3.30427 13.6317 3.00467 13.0437C2.66406 12.3752 2.66406 11.5002 2.66406 9.75Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91406 7.875V11.625M8.91406 11.625L10.4766 10.0625M8.91406 11.625L7.35156 10.0625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.9f0dd9221cba12fe43269a8056c18bea.svg";
export { ForwardRef as ReactComponent };